const registerI18n = {
  "fr": {
    "title": "Créer un compte",
    "subtitle": "Inscris-toi pour accéder à ton espace.",
    "form": {
      "email": "Email",
      "company": "Entreprise",
      "phone": "Numéro de téléphone",
      "password": "Mot de passe",
      "confirm": "Confirmer le mot de passe",
      "minlen": "6 caractères minimum",
      "submit": "S'inscrire",
      "loading": "Création du compte…"
    },
    "login": {
      "prompt": "Déjà inscrit ?",
      "link": "Se connecter"
    },
    "success": {
      "accountCreated": "Compte créé avec succès."
    },
    "errors": {
      "emailInvalid": "Adresse e-mail invalide.",
      "emailDomainTypo": "Domaine suspect. Vouliez-vous « {{suggestion}} » ?",
      "emailDomainTypoBlock": "Votre domaine semble incorrect. Vouliez-vous « {{suggestion}} » ?",
      "requiredFields": "Champs obligatoires manquants (email, téléphone, mot de passe).",
      "passwordLen": "Le mot de passe doit contenir au moins 6 caractères.",
      "confirmMismatch": "Les mots de passe ne correspondent pas.",
      "createFailed": "Impossible de créer le compte. L'email est peut-être déjà utilisé."
    }
  },
  "en": {
    "title": "Create an account",
    "subtitle": "Sign up to access your dashboard.",
    "form": {
      "email": "Email",
      "company": "Company",
      "phone": "Phone number",
      "password": "Password",
      "confirm": "Confirm password",
      "minlen": "Minimum 6 characters",
      "submit": "Sign up",
      "loading": "Creating account…"
    },
    "login": {
      "prompt": "Already registered?",
      "link": "Log in"
    },
    "success": {
      "accountCreated": "Account created successfully."
    },
    "errors": {
      "emailInvalid": "Invalid email address.",
      "emailDomainTypo": "Suspicious domain. Did you mean “{{suggestion}}”?",
      "emailDomainTypoBlock": "Your domain looks wrong. Did you mean “{{suggestion}}”?",
      "requiredFields": "Required fields missing (email, phone, password).",
      "passwordLen": "Password must be at least 6 characters.",
      "confirmMismatch": "Passwords do not match.",
      "createFailed": "Could not create the account. The email may already be in use."
    }
  },
  "pl": {
    "title": "Utwórz konto",
    "subtitle": "Zarejestruj się, aby uzyskać dostęp do panelu.",
    "form": {
      "email": "Email",
      "company": "Firma",
      "phone": "Numer telefonu",
      "password": "Hasło",
      "confirm": "Potwierdź hasło",
      "minlen": "Minimum 6 znaków",
      "submit": "Zarejestruj się",
      "loading": "Tworzenie konta…"
    },
    "login": {
      "prompt": "Masz już konto?",
      "link": "Zaloguj się"
    },
    "success": {
      "accountCreated": "Konto zostało utworzone."
    },
    "errors": {
      "emailInvalid": "Nieprawidłowy adres e-mail.",
      "emailDomainTypo": "Podejrzana domena. Czy chodziło o „{{suggestion}}”?",
      "emailDomainTypoBlock": "Wygląda na błąd w domenie. Czy chodziło o „{{suggestion}}”?",
      "requiredFields": "Brak wymaganych pól (email, telefon, hasło).",
      "passwordLen": "Hasło musi mieć co najmniej 6 znaków.",
      "confirmMismatch": "Hasła nie są identyczne.",
      "createFailed": "Nie udało się utworzyć konta. Ten email może być już używany."
    }
  },
  "es": {
    "title": "Crear una cuenta",
    "subtitle": "Regístrate para acceder a tu espacio.",
    "form": {
      "email": "Email",
      "company": "Empresa",
      "phone": "Número de teléfono",
      "password": "Contraseña",
      "confirm": "Confirmar contraseña",
      "minlen": "Mínimo 6 caracteres",
      "submit": "Registrarse",
      "loading": "Creando la cuenta…"
    },
    "login": {
      "prompt": "¿Ya tienes una cuenta?",
      "link": "Iniciar sesión"
    },
    "success": {
      "accountCreated": "Cuenta creada con éxito."
    },
    "errors": {
      "emailInvalid": "Dirección de email no válida.",
      "emailDomainTypo": "Dominio sospechoso. ¿Quisiste decir «{{suggestion}}»?",
      "emailDomainTypoBlock": "Tu dominio parece incorrecto. ¿Quisiste decir «{{suggestion}}»?",
      "requiredFields": "Faltan campos obligatorios (email, teléfono, contraseña).",
      "passwordLen": "La contraseña debe tener al menos 6 caracteres.",
      "confirmMismatch": "Las contraseñas no coinciden.",
      "createFailed": "No se pudo crear la cuenta. Es posible que el email ya esté en uso."
    }
  },
  "it": {
    "title": "Creare un account",
    "subtitle": "Iscriviti per accedere al tuo cruscotto.",
    "form": {
      "email": "Email",
      "company": "Società",
      "phone": "Numero di telefono",
      "password": "Password",
      "confirm": "Conferma la password",
      "minlen": "Minimo 6 caratteri",
      "submit": "Registrati",
      "loading": "Creazione di account..."
    },
    "login": {
      "prompt": "Sei già registrato?",
      "link": "Accedi"
    },
    "success": {
      "accountCreated": "Account creato con successo."
    },
    "errors": {
      "emailInvalid": "Indirizzo email non valido.",
      "emailDomainTypo": "Dominio sospetto. Vuoi dire \"{{suggestion}}\"?",
      "emailDomainTypoBlock": "Il tuo dominio sembra sbagliato. Vuoi dire \"{{suggestion}}\"?",
      "requiredFields": "Campi obbligatori mancanti (email, telefono, password).",
      "passwordLen": "La password deve essere di almeno 6 caratteri.",
      "confirmMismatch": "Le password non corrispondono.",
      "createFailed": "Non poteva creare l'account. L'email può già essere in uso."
    }
  },
  "de": {
    "title": "Erstellen Sie ein Konto",
    "subtitle": "Melden Sie sich an, um auf Ihr Dashboard zuzugreifen.",
    "form": {
      "email": "E-Mail",
      "company": "Unternehmen",
      "phone": "Telefonnummer",
      "password": "Passwort",
      "confirm": "Passwort bestätigen",
      "minlen": "Mindestens 6 Zeichen",
      "submit": "Anmelden",
      "loading": "Konto erstellen..."
    },
    "login": {
      "prompt": "Bereits registriert?",
      "link": "Anmelden"
    },
    "success": {
      "accountCreated": "Account erfolgreich erstellt."
    },
    "errors": {
      "emailInvalid": "Ungültige E-Mail-Adresse.",
      "emailDomainTypo": "Verdächtige Domain. Meintest du \"{{suggestion}}\"?",
      "emailDomainTypoBlock": "Ihre Domain sieht falsch aus. Meintest du \"{{suggestion}}\"?",
      "requiredFields": "Erforderliche Felder fehlen (E-Mail, Telefon, Passwort).",
      "passwordLen": "Das Passwort muss mindestens 6 Zeichen umfassen.",
      "confirmMismatch": "Passwörter passen nicht zusammen.",
      "createFailed": "Das Konto konnte nicht erstellt werden. Möglicherweise ist die E-Mail bereits in Gebrauch."
    }
  },
  "pt": {
    "title": "Criar uma conta",
    "subtitle": "Inscreva-se para aceder ao painel.",
    "form": {
      "email": "E- mail",
      "company": "Empresa",
      "phone": "Número de telefone",
      "password": "Senha",
      "confirm": "Confirmar senha",
      "minlen": "No mínimo 6 caracteres",
      "submit": "Inscreva-se",
      "loading": "Criando conta..."
    },
    "login": {
      "prompt": "Já está registado?",
      "link": "Entrar"
    },
    "success": {
      "accountCreated": "Conta criada com sucesso."
    },
    "errors": {
      "emailInvalid": "Endereço de e- mail inválido.",
      "emailDomainTypo": "Domínio suspeito. Você quis dizer \"{{suggestion}}\"?",
      "emailDomainTypoBlock": "Seu domínio parece errado. Você quis dizer \"{{suggestion}}\"?",
      "requiredFields": "Campos obrigatórios em falta (e-mail, telefone, senha).",
      "passwordLen": "A senha deve ter pelo menos 6 caracteres.",
      "confirmMismatch": "As senhas não correspondem.",
      "createFailed": "Não foi possível criar a conta. O e-mail já pode estar em uso."
    }
  },
  "cs": {
    "title": "Vytvořit účet",
    "subtitle": "Zaregistrujte se pro přístup k vaší palubní desce.",
    "form": {
      "email": "E-mail",
      "company": "Společnost",
      "phone": "Číslo telefonu",
      "password": "Heslo",
      "confirm": "Potvrdit heslo",
      "minlen": "Nejméně 6 znaků",
      "submit": "Zaregistrujte se",
      "loading": "Vytvoření účtu..."
    },
    "login": {
      "prompt": "Už jste registrovaný?",
      "link": "Přihlásit se"
    },
    "success": {
      "accountCreated": "Úspěšně vytvořený účet."
    },
    "errors": {
      "emailInvalid": "Neplatná e-mailová adresa.",
      "emailDomainTypo": "Podezřelá doména. Myslel jste{{suggestion}}?",
      "emailDomainTypoBlock": "Vaše doména vypadá špatně. Myslel jste{{suggestion}}?",
      "requiredFields": "Požadovaná pole chybí (e-mail, telefon, heslo).",
      "passwordLen": "Heslo musí mít alespoň 6 znaků.",
      "confirmMismatch": "Hesla se neshodují.",
      "createFailed": "Nelze vytvořit účet. E-mail může být již v provozu."
    }
  },
  "nl": {
    "title": "Een account aanmaken",
    "subtitle": "Meld je aan om toegang te krijgen tot je dashboard.",
    "form": {
      "email": "E-mail",
      "company": "Onderneming",
      "phone": "Telefoonnummer",
      "password": "Wachtwoord",
      "confirm": "Wachtwoord bevestigen",
      "minlen": "Minimum 6 tekens",
      "submit": "Aanmelden",
      "loading": "Account aanmaken..."
    },
    "login": {
      "prompt": "Al geregistreerd?",
      "link": "Aanmelden"
    },
    "success": {
      "accountCreated": "Account succesvol aangemaakt."
    },
    "errors": {
      "emailInvalid": "Ongeldig e-mailadres.",
      "emailDomainTypo": "Verdacht domein. Bedoel je{{suggestion}}?",
      "emailDomainTypoBlock": "Uw domein ziet er verkeerd uit. Bedoel je{{suggestion}}?",
      "requiredFields": "Verplichte velden ontbreken (e-mail, telefoon, wachtwoord).",
      "passwordLen": "Wachtwoord moet minstens 6 tekens zijn.",
      "confirmMismatch": "Wachtwoorden komen niet overeen.",
      "createFailed": "Kon het account niet aanmaken. De e-mail kan al in gebruik zijn."
    }
  }
};

export default registerI18n;
